import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader, Dropdown} from 'semantic-ui-react';
import {pageSizes} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import TablePaginator from '../../../common/components/tablePaginator';
import VerifyBox from '../verifyBox/index';

class VerifyPendingItemsInvoiceToBin extends Component {
  constructor(props) {
    super(props);
    this.onPageClick = this.onPageClick.bind(this);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
  }
  componentDidMount() {
    this.props.changeVerifyInvoiceListPage(0);
    this.props.changeVerifyInvoiceListPageSize(20);
  }

  renderBody() {
    const {loading, invoicesList} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderBoxes(invoicesList);
  }

  renderBoxes(list) {
    const {invoice} = this.props;

    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%' textAlign='center'>
            No se encuentran datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center' className='right-divider'>
            {element.box}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.expectedLines}</Table.Cell>
          <Table.Cell textAlign='center'>{element.receivedLines}</Table.Cell>
          <Table.Cell textAlign='center' className='right-divider'>
            {element.pendingLines}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.expectedQuantity}</Table.Cell>
          <Table.Cell textAlign='center'>{element.receivedQuantity}</Table.Cell>
          <Table.Cell textAlign='center' className='right-divider'>
            {element.pendingQuantity}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <VerifyBox invoice={invoice} box={element.box} />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  onPageClick(value) {
    this.props.changeVerifyInvoiceListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeVerifyInvoiceListPageSize(data.value);
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <Card fluid raised>
        <Table striped className='toyota-grid primary-content'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center' className='right-divider'>
                Caja
              </Table.HeaderCell>
              <Table.HeaderCell
                textAlign='center'
                colSpan={3}
                className='right-divider'
              >
                Líneas
              </Table.HeaderCell>
              <Table.HeaderCell
                textAlign='center'
                colSpan={3}
                className='header-secondary right-divider'
              >
                Cantidad
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' />
            </Table.Row>
          </Table.Header>

          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center' className='right-divider' />
              <Table.HeaderCell textAlign='center'>Factura</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Revisión</Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='right-divider'>
                Diferencia
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='header-secondary'>
                Factura
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='header-secondary'>
                Revisión
              </Table.HeaderCell>
              <Table.HeaderCell
                textAlign='center'
                className='header-secondary right-divider'
              >
                Diferencia
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' />
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderBody()}</Table.Body>

          {this.renderPagination()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'pageNumber': state.verifyInvoice.pageNumber,
    'pageSize': state.verifyInvoice.pageSize,
  };
};

const {
  changeVerifyInvoiceListPage,
  changeVerifyInvoiceListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  changeVerifyInvoiceListPage,
  changeVerifyInvoiceListPageSize,
})(VerifyPendingItemsInvoiceToBin);
